export const LOADING_CHARTOFACCOUNT = "LOADING_CHARTOFACCOUNT";
export const GET_CHARTOFACCOUNT_LIST = "GET_CHARTOFACCOUNT_LIST";
export const ADD_CHARTOFACCOUNT = "ADD_CHARTOFACCOUNT";
export const REMOVE_CHARTOFACCOUNT = "REMOVE_CHARTOFACCOUNT";
export const UPDATE_CHARTOFACCOUNT = "UPDATE_CHARTOFACCOUNT";
export const GET_CHARTOFACCOUNT_ID = "GET_CHARTOFACCOUNT_ID";
